<aside class="sidebar">
  <nav>
    <a routerLink="/imoveis" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
      routerLinkActive="active">
      <iconify-icon icon="mdi:home-city-outline" width="20" height="20"></iconify-icon>
      <span>Imóveis</span>
    </a>

    <a *ngIf="isAdmin" routerLink="/proprietarios" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
      <iconify-icon icon="mdi:account-tie-outline" width="20" height="20"></iconify-icon>
      <span>Proprietários</span>
    </a>

    <a routerLink="/locatarios" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
      <iconify-icon icon="mdi:account-outline" width="20" height="20"></iconify-icon>
      <span>Locatários</span>
    </a>

    <a  routerLink="/chaves" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
      <iconify-icon icon="mdi:key-outline" width="20" height="20"></iconify-icon>
      <span>Chaves</span>
    </a>

    <a routerLink="/calculadora" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
      <iconify-icon icon="mdi:calculator" width="20" height="20"></iconify-icon>
      <span>Calc. de Empréstimo</span>
    </a>
  </nav>
</aside>
